import { html } from "../../render";
import { attr, cn, safeRandomId, spreadAttrs } from "../../utils";
import { LpIcon } from "../../components/icon";
const pageHeaderManagedAttrs = [
    "data-lp-component",
    "class",
    "aria-labelledby",
    "aria-describedby",
];
function hasContent(value) {
    if (value === undefined || value === null || value === false || value === "") {
        return false;
    }
    if (typeof value === "object"
        && typeof value[Symbol.iterator] === "function") {
        return Array.from(value).some(hasContent);
    }
    return true;
}
export function LpPageHeader({ title, description, breadcrumbs, actions, controls, controlActions, stickyControls = true, className, attributes, }) {
    const id = safeRandomId();
    const titleId = `lp-page-header-title-${id}`;
    const descriptionId = `lp-page-header-description-${id}`;
    const breadcrumbItems = breadcrumbs ?? [];
    const hasDescription = hasContent(description);
    const hasBreadcrumbs = breadcrumbItems.length > 0;
    const hasActions = hasContent(actions);
    const hasControls = hasContent(controls);
    const hasControlActions = hasContent(controlActions);
    const hasControlStrip = hasControls || hasControlActions;
    return html `
        <section
            data-lp-component="PageHeader"
            class="${cn("lp-page-header", className, attributes?.class)}"
            aria-labelledby="${titleId}"
            ${attr("aria-describedby", hasDescription ? descriptionId : undefined)}
            ${spreadAttrs(attributes, { omit: pageHeaderManagedAttrs })}
        >
            <header class="lp-page-header_header">
                <div class="lp-page-header_header-inner">
                    <div class="lp-page-header_heading">
                        ${hasBreadcrumbs
        ? html `
                                <nav class="lp-page-header_breadcrumbs" aria-label="Breadcrumb">
                                    <ol class="lp-page-header_breadcrumb-list">
                                        ${breadcrumbItems.map((breadcrumb, index) => {
            const isCurrent = index === breadcrumbItems.length - 1;
            return html `
                                                <li class="lp-page-header_breadcrumb-item">
                                                    ${breadcrumb.href && !isCurrent
                ? html `
                                                            <a class="lp-page-header_breadcrumb-link" href="${breadcrumb.href}">
                                                                ${breadcrumb.label}
                                                            </a>
                                                        `
                : html `
                                                            <span
                                                                class="lp-page-header_breadcrumb-current"
                                                                ${attr("aria-current", isCurrent ? "page" : undefined)}
                                                            >
                                                                ${breadcrumb.label}
                                                            </span>
                                                        `}
                                                    ${!isCurrent
                ? LpIcon({
                    name: "caret-right",
                    size: 12,
                    className: "lp-page-header_breadcrumb-separator",
                })
                : ""}
                                                </li>
                                            `;
        })}
                                    </ol>
                                </nav>
                            `
        : ""}
                        <div class="lp-page-header_title-row">
                            <h1 id="${titleId}" class="lp-page-header_title">${title}</h1>
                        </div>
                        ${hasDescription
        ? html `
                                <p id="${descriptionId}" class="lp-page-header_description">
                                    ${description}
                                </p>
                            `
        : ""}
                    </div>
                    ${hasActions
        ? html `<div class="lp-page-header_actions">${actions}</div>`
        : ""}
                </div>
            </header>
            ${hasControlStrip
        ? html `
                    <div
                        class="lp-page-header_control-strip"
                        ${attr("data-sticky", stickyControls)}
                    >
                        <div class="lp-page-header_control-strip-inner">
                            ${hasControls
            ? html `<div class="lp-page-header_controls">${controls}</div>`
            : ""}
                            ${hasControlActions
            ? html `
                                    <div class="lp-page-header_control-actions">
                                        ${controlActions}
                                    </div>
                                `
            : ""}
                        </div>
                    </div>
                `
        : ""}
        </section>
    `;
}
